import { render, staticRenderFns } from "./StudyNewPageBodyModals.vue?vue&type=template&id=6eff72d7&scoped=true"
import script from "./StudyNewPageBodyModals.vue?vue&type=script&lang=js"
export * from "./StudyNewPageBodyModals.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageBodyModals.vue?vue&type=style&index=0&id=6eff72d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff72d7",
  null
  
)

export default component.exports